import * as React from "react";
import Link from "next/link";
import { IMobileAccess } from "@nju/data-access-portal-product";
import { portalRoutes } from "@nju/routes";
import { A, Button } from "@nju/ui";
import { MobileReactivationButton } from "./MobileReactivationButton";
import { IMobileServiceCTABannerConditions } from "./types";

interface IButtonsProps {
  handleCancelServiceResignation?: () => void;
  isCancelServiceResignationLoading?: boolean;
  refreshCallback: () => void;
  mobileAccess?: IMobileAccess | undefined;
  conditions: IMobileServiceCTABannerConditions;
  userId: string | undefined;
  offerId?: string;
}

export function Buttons({
  isCancelServiceResignationLoading,
  handleCancelServiceResignation,
  refreshCallback,
  mobileAccess,
  conditions,
  userId,
  offerId,
}: IButtonsProps) {
  const {
    isPendingCancellation,
    isPortoutCancellationPossible,
    isNoPayment,
    isSuspended,
    isPendingTermination,
    isPendingReactivation,
    isUnsubscribed,
    isDisconnected,
  } = conditions;

  if (isPendingCancellation || isPendingTermination || isPendingReactivation) {
    return (
      <div className="flex only-mobile:flex-col">
        <Button
          onPress={() => {
            refreshCallback();
          }}
          size={{
            "@onlyMobile": "s",
          }}
        >
          odśwież
        </Button>
      </div>
    );
  }

  if (isPortoutCancellationPossible) {
    return (
      <div className="flex only-mobile:flex-col">
        <Link
          href={portalRoutes.mojeKonto.anulujPrzeniesienie.index.get({
            mode: "mobile",
            ...(userId && { userId }),
          })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            anuluj przeniesienie numeru
          </A>
        </Link>
      </div>
    );
  }

  if (isNoPayment && mobileAccess?.statusChangeDate) {
    return (
      <Link
        href={portalRoutes.mojeKonto.platnosci.historia.get({
          ostatniaNieudanaPlatnosc: "1",
        })}
        passHref={true}
      >
        <A
          display="inlineBlock"
          size={{
            "@onlyMobile": "s",
          }}
        >
          szczegóły płatności
        </A>
      </Link>
    );
  }

  if (isUnsubscribed && handleCancelServiceResignation) {
    return (
      <Button
        isLoading={isCancelServiceResignationLoading}
        onPress={() => {
          return handleCancelServiceResignation();
        }}
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
      >
        anuluj rezygnację z usługi
      </Button>
    );
  }

  if (
    (isSuspended || isDisconnected) &&
    mobileAccess?.statusChangeDate &&
    mobileAccess?.terminationDate
  ) {
    return <MobileReactivationButton offerId={offerId} userId={userId} />;
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
